<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-users-class" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{ session.title }}</div>
            <div class="meta" v-if="session.presenter"><i class="fas fa-user-tie fa-fw mr-2"></i>{{session.presenter}}</div>
            <div class="meta" v-if="session.conferences.is_show_tracks && session.conf_session_tracks"><i class="far fa-code-branch fa-fw mr-2"></i>{{session.conf_session_tracks.title}}</div>
            <div class="meta" v-if="session.conferences.is_show_groups && session.conf_session_groups"><i class="far fa-layer-group fa-fw mr-2"></i>{{session.conf_session_groups.title}}</div>
            <div class="meta" v-if="session.type !== 'on_demand'"><i class="far fa-clock fa-fw mr-2"></i>{{sessDates}} ({{session.type | capitalize}})</div>
            <div class="meta" v-if="session.type === 'on_demand'"><i class="far fa-play fa-fw mr-2"></i>On-Demand</div>
            <div class="meta has-text-warning" v-if="!session.is_active"><i class="far fa-ban fa-fw mr-2"></i>Session Disabled</div>
            <div class="meta has-text-warning" v-if="!session.is_visible"><i class="far fa-ban fa-fw mr-2"></i>Session Hidden</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">

                </span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'ConfSessionTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            session: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        },
        computed: {
            sessDates: function() {
                let s = moment(this.session.start_at);
                let e = moment(this.session.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMM D, YYYY h:mm A - ') +  e.format('h:mm A');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMM D, h:mm A - ') + e.format('D, h:mm A, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D, h:mm A - ') + e.format('D, h:mm A, YYYY');
                } else {
                    return s.format('MMM D, YYYY h:mm A - ') + e.format('MMM D, YYYY h:mm A');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
